import React from "react";
import Icon from "@cc/react-components/Icon";
import Alert from "@cc/react-components/Alert";
import IconType from "@cc/react-components/IconType";

interface Props {
  title?: string;
  message: string;
  iconType?: IconType;
}

const BlockingMessage = ({ title, message, iconType }: Props) => {
  return (
    <div className="h-100 d-flex flex-column align-items-center">
      {iconType && <Icon type={iconType} size="10x" />}
      <Alert variant="warning">
        {title && <Alert.Heading>{title}</Alert.Heading>}
        {message}
      </Alert>
    </div>
  );
};

export default BlockingMessage;
